import type { ReactNode } from "react";
export function StatusBanner({
	kind,
	children,
}: {
	kind: "info" | "success" | "warning" | "error";
	children: ReactNode;
}) {
	return (
		<div className={`status status-${kind}`} role={kind === "error" ? "alert" : "status"} aria-live="polite">
			{children}
		</div>
	);
}
